import { DcsProgressbarComponent } from './dcs-progressbar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [DcsProgressbarComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [DcsProgressbarComponent],
})
export class DcsprogressbarModule { }
